import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FINANCE, FORM_AUTO, POINT_OF_SALE, REQUEST_DATA } from '@app/@core/constants/requests.constants';
import { RequestsSaveSendStore } from '../requests-save-send-service/requests-save-send.store';
import { CalculatorAutosDTO } from '../model/requests-model';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { Subject } from 'rxjs';
import { CommonDataDTO } from '../model/combos-model';

@Component({
  selector: 'app-calculator-autos',
  templateUrl: './calculator-autos.component.html',
  styleUrls: ['./calculator-autos.component.scss'],
})
export class CalculatorAutosComponent implements OnInit, OnDestroy {
  public establishment: string;
  public dataFinance: CalculatorAutosDTO;
  public expirationMonth: string;
  public operative: string = null;
  public selectedProductLine: string = null;
  public requestedAmount: string = null;
  public priceProduct: string = null;
  public start: string = null;
  public vendor: CommonDataDTO;
  public maxAmount: any;

  changingValueClearTable: Subject<boolean> = new Subject();

  //Loading
  private isPointOfSaleLoaded: boolean = false;
  private isRequestDataLoaded: boolean = false;
  private isFinanceLoaded: boolean = false;

  constructor(
    private requestsStore: RequestsSaveSendStore,
    private router: Router,
    private cdref: ChangeDetectorRef,
    private loaderGenericService: LoaderGenericService
  ) {}

  ngOnInit(): void {
    this.requestsStore.listaFormulariosAutos = [];
    this.requestsStore.setMarcaFormulario(FORM_AUTO);
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnDestroy(): void {}

  public changeContinueStatusForms(formAuto: any) {
    this.requestsStore.listaFormulariosAutos[formAuto.id] = formAuto.form;
  }

  switchScreenAlta(event: boolean) {
    if (event) {
      this.requestsStore.setCalculatorData(true);
      this.router.navigate(['/requests/request-auto'], { replaceUrl: true });
    }
  }

  public openCalculateFinance(data: CalculatorAutosDTO) {
    this.dataFinance = data;
  }

  public setExpiredMonth(month: string) {
    this.expirationMonth = month;
  }

  public updateCombos(establishment: string) {
    this.establishment = establishment;
  }

  public updateOperative(operative: string) {
    this.operative = operative;
  }

  public updateSelectedProductLine(productLine: string) {
    this.selectedProductLine = productLine;
  }

  public updateRequestedAmount(requestedAmount: string) {
    this.requestedAmount = requestedAmount;
  }

  public updateCombosVendor(vendor: CommonDataDTO) {
    this.vendor = vendor;
    this.tellChildClearTable();
    this.requestsStore.listaFormulariosAutos[FINANCE].reset();
  }

  public updatePriceProduct(priceProduct: string) {
    this.priceProduct = priceProduct;
  }

  public updateStart(start: string) {
    this.start = start;
  }

  public changeContinueLoadingStatus(loadingState: any) {
    const formID = loadingState.formID;
    const value = loadingState.value;
    if (formID === POINT_OF_SALE) {
      this.isPointOfSaleLoaded = value;
    } else if (formID === REQUEST_DATA) {
      this.isRequestDataLoaded = value;
    } else if (formID === FINANCE) {
      this.isFinanceLoaded = value;
    }
    this.triggerStopLoader();
  }

  public tellChildClearTable() {
    this.changingValueClearTable.next(false);
  }

  private triggerStopLoader(): void {
    console.log('trigger', [this.isPointOfSaleLoaded, this.isRequestDataLoaded, this.isFinanceLoaded]);
    if (this.isPointOfSaleLoaded && this.isRequestDataLoaded && this.isFinanceLoaded) {
      this.loaderGenericService.stopSpinner();
    } else {
      this.loaderGenericService.showSpinner();
    }
  }
}
